var _path, _path2, _path3, _path4, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSaleorderWeb({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "journal-check",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.931,
    height: 23.001,
    viewBox: "0 0 24.931 23.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_281",
    "data-name": "Trazado 281",
    d: "M12.836,6.2a.685.685,0,0,1,0,.97l-4.11,4.11a.685.685,0,0,1-.97,0L5.7,9.226a.686.686,0,0,1,.97-.97L8.24,9.827,11.866,6.2a.685.685,0,0,1,.97,0Z",
    transform: "translate(2.035 2.22)",
    fill: "#003082",
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_282",
    "data-name": "Trazado 282",
    d: "M3.74,0h13.7a2.74,2.74,0,0,1,2.74,2.74V19.182a2.74,2.74,0,0,1-2.74,2.74H3.74A2.74,2.74,0,0,1,1,19.182v-1.37H2.37v1.37a1.37,1.37,0,0,0,1.37,1.37h13.7a1.37,1.37,0,0,0,1.37-1.37V2.74a1.37,1.37,0,0,0-1.37-1.37H3.74A1.37,1.37,0,0,0,2.37,2.74V4.11H1V2.74A2.74,2.74,0,0,1,3.74,0Z",
    transform: "translate(0.37)",
    fill: "#003082"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_283",
    "data-name": "Trazado 283",
    d: "M1.37,5.37V4.685a.685.685,0,0,1,1.37,0V5.37h.685a.685.685,0,0,1,0,1.37H.685a.685.685,0,0,1,0-1.37Zm0,8.221v-.685a.685.685,0,1,1,1.37,0v.685h.685a.685.685,0,1,1,0,1.37H.685a.685.685,0,1,1,0-1.37Z",
    transform: "translate(0 1.48)",
    fill: "#003082"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2306",
    "data-name": "Trazado 2306",
    d: "M1.342,19.7v-.671a.671.671,0,1,1,1.342,0V19.7h.671a.671.671,0,1,1,0,1.342H.671a.671.671,0,0,1,0-1.342Z",
    transform: "translate(0.043 -8.738)",
    fill: "#003082"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18092",
    "data-name": "Grupo 18092",
    transform: "translate(-117.5 -351.781)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_7670",
    "data-name": "Rect\\xE1ngulo 7670",
    width: 12.431,
    height: 7.563,
    transform: "translate(130 367.219)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Awwwards--Streamline-Simple-Icons",
    d: "M6.4,5.6,5.424,9.372,4.5,5.6H3.247L2.325,9.372,1.352,5.6H0l1.743,5.5H2.934l.943-3.555L4.815,11.1H6.006L7.749,5.6Zm2.217,4.65a.908.908,0,1,0,.9-.921.89.89,0,0,0-.9.921",
    transform: "translate(131 362.619)",
    fill: "#003082"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaleorderWeb);
export default __webpack_public_path__ + "static/media/saleorder-web.2447160e1d989148f0cdfd347f5c668c.svg";
export { ForwardRef as ReactComponent };